import { defineComponent as l, createBlock as r, openBlock as t, unref as c, mergeProps as i, withCtx as a, createElementVNode as p } from "vue";
import { RevIcon as d } from "@ds/components/Icon";
const f = /* @__PURE__ */ l({
  name: "IconCheckInCircleFilled",
  __name: "IconCheckInCircleFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(n) {
    const o = n;
    return (m, e) => (t(), r(c(d), i(o, { "view-box": "0 0 24 24" }), {
      default: a(() => [...e[0] || (e[0] = [
        p("path", {
          "fill-rule": "evenodd",
          d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12m14.78-2.47a.75.75 0 0 0-1.06-1.06l-5.47 5.47-2.47-2.47a.75.75 0 0 0-1.06 1.06l2.646 2.647a1.25 1.25 0 0 0 1.768 0L17.03 9.53",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
